module.exports = __webpack_public_path__ + "static/icons/icon-amex-logo.ffcb14a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons-tarjeta-credito/icon-amex-logo.svg
// module id = +qqH
// module chunks = 1